import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBatteryLow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconBatteryLow"><Path fillRule="evenodd" clipRule="evenodd" d="M2.75 5C1.7835 5 1 5.7835 1 6.75V17.25C1 18.2165 1.7835 19 2.75 19H18.25C19.2165 19 20 18.2165 20 17.25V16H21.75C22.4404 16 23 15.4404 23 14.75V9.25C23 8.55964 22.4404 8 21.75 8H20V6.75C20 5.7835 19.2165 5 18.25 5H2.75ZM20 9.5V14.5H21.5V9.5H20ZM6 9C6.41421 9 6.75 9.33579 6.75 9.75V14.25C6.75 14.6642 6.41421 15 6 15C5.58579 15 5.25 14.6642 5.25 14.25V9.75C5.25 9.33579 5.58579 9 6 9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBatteryLow;
